import { create } from "zustand";
import type { WallOfLoveTemplateState } from "../types";
import { wallOfLoveTemplateApi } from "../services/wall-of-love-template-api";

export const useWallOfLoveTemplateStore = create<WallOfLoveTemplateState>((set) => ({
	template: null,
	templates: null,
	index: async () => {
		const response = await wallOfLoveTemplateApi.index();
		set({ templates: response.data });
		return response;
	},
	show: async (template: string, version: number) => {
		const response = await wallOfLoveTemplateApi.show(template, version);
		set({ template: response.data });
		return response;
	},
}));